// Supabase client + the user-row helpers the Clerk login flow calls into.
// Migrated off the CDN bundle to the npm @supabase/supabase-js package so
// the client lives inside our bundle (no extra network round-trip, real
// types in IDEs, no UMD globals required).

import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = window.AUTH_CONFIG?.supabase?.url || "";
const SUPABASE_ANON_KEY = window.AUTH_CONFIG?.supabase?.anonKey || "";
const USERS_TABLE = "communityninja_users";

const USER_ID_KEY = "cn_user_id";

let client = null;
function getClient() {
  if (client) return client;
  if (!SUPABASE_URL || !SUPABASE_ANON_KEY) return null;
  client = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
  return client;
}
window.getSupabase = getClient;

// Pulls the Google sub out of Clerk's externalAccounts and formats it as
// `google-oauth2|<sub>`. Falls back to the Clerk user id only if no Google
// account is linked (e.g. email/password sign-in).
function resolveUserId(clerkUser) {
  if (!clerkUser) return null;
  const accounts = clerkUser.externalAccounts || [];
  const google = accounts.find((a) => {
    const provider = (a?.provider || "").toLowerCase();
    return provider === "google" || provider === "oauth_google";
  });
  const sub = google?.providerUserId || google?.externalId || null;
  if (sub) return `google-oauth2|${sub}`;
  return clerkUser.id || null;
}
window.resolveUserId = resolveUserId;

function readStoredUserId() {
  try { return localStorage.getItem(USER_ID_KEY) || null; } catch (e) { return null; }
}
function writeStoredUserId(id) {
  try {
    if (id) localStorage.setItem(USER_ID_KEY, id);
    else localStorage.removeItem(USER_ID_KEY);
  } catch (e) {}
}
window.getStoredUserId = readStoredUserId;
window.setStoredUserId = writeStoredUserId;

window.upsertSupabaseUser = async function (clerkUser) {
  const c = getClient();
  if (!c || !clerkUser) return null;
  const userId = resolveUserId(clerkUser);
  if (userId) writeStoredUserId(userId);

  const email =
    clerkUser.primaryEmailAddress?.emailAddress ||
    clerkUser.emailAddresses?.[0]?.emailAddress ||
    null;
  const fullName = [clerkUser.firstName, clerkUser.lastName]
    .filter(Boolean)
    .join(" ")
    .trim();
  const row = {
    user_id: userId,
    name: fullName || clerkUser.username || email,
    email,
    updated_at: new Date().toISOString(),
  };
  const { data, error } = await c
    .from(USERS_TABLE)
    .upsert(row, { onConflict: "user_id" })
    .select()
    .single();
  if (error) {
    console.warn("Supabase user upsert failed:", error.message);
    return null;
  }
  return data;
};

window.getSupabaseUserById = async function (userId) {
  const c = getClient();
  if (!c || !userId) return null;
  const { data, error } = await c
    .from(USERS_TABLE)
    .select("*")
    .eq("user_id", userId)
    .maybeSingle();
  if (error) {
    console.warn("Supabase user lookup failed:", error.message);
    return null;
  }
  return data;
};
